import React from 'react';

import { colors } from 'inpock-ui-react/dist/src/color';
import { Paragraph2, SmallText } from 'inpock-ui-react';

import { scale } from '@/utils';

import { Box } from '../Box';
import { Accordion } from '../Accordion';

interface FooterProps {
  seller_company_name: string;
}

export function Footer({ seller_company_name }: FooterProps) {
  return (
    <footer style={{ paddingBottom: '80px' }}>
      <Box sx={{ backgroundColor: colors.gray100, padding: scale.large }}>
        <div className="d-flex mb-10" style={{ gap: '12px' }}>
          <SmallText className="text-bold text-gray-600">서비스 제공자</SmallText>
          <SmallText color="gray600">에이비제트(주)</SmallText>
        </div>
        <SmallText color="gray500">
          {seller_company_name}은/는 통신판매의 당사자가 아닙니다. 상품, 상품정보, 거래에 관한
          의무와 책임은 판매자에게 있습니다.
        </SmallText>
      </Box>
      <Accordion
        headerBgColor="gray100"
        firstRow={
          <Box flex alignItems="center">
            <Paragraph2 style={{ marginRight: scale.large }}>ⓒ ABZ Inc. 2023</Paragraph2>
            <a
              href="https://terms.inpock.co.kr/market/member/terms"
              target="_blank"
              rel="noreferrer"
            >
              <SmallText style={{ marginRight: scale.large }} color="gray500">
                이용약관
              </SmallText>
            </a>

            <a
              href="https://terms.inpock.co.kr/market/member/privacy"
              target="_blank"
              rel="noreferrer"
            >
              <SmallText style={{ textDecoration: 'underline' }}>개인정보처리방침</SmallText>
            </a>
          </Box>
        }
      >
        <Box
          flex
          flexDirection="column"
          sx={{
            padding: scale.large,
          }}
        >
          <a
            href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1258701240"
            target="_blank"
            rel="noreferrer"
          >
            <SmallText
              fontWeight="bold"
              color="gray500"
              style={{ textDecoration: 'underline', marginBottom: scale.xsmall }}
            >
              사업자정보 확인
            </SmallText>
          </a>
          <SmallText color="gray500" style={{ marginBottom: scale.xsmall }} fontWeight="bold">
            <span>대표</span> 최하림
          </SmallText>
          <SmallText color="gray500" style={{ marginBottom: scale.xsmall }} fontWeight="bold">
            <span>사업자등록번호</span> 125-87-01240
          </SmallText>
          <SmallText color="gray500" style={{ marginBottom: scale.xsmall }} fontWeight="bold">
            <span>통신판매번호</span> 2022-서울서초-1050
          </SmallText>
          <SmallText color="gray500" style={{ marginBottom: scale.xsmall }} fontWeight="bold">
            <span>대표번호</span> 070-5222-7724
          </SmallText>
          <SmallText color="gray500" style={{ marginBottom: scale.xsmall }} fontWeight="bold">
            <span>주소</span> 서울시 서초구 강남대로 311 드림플러스 강남, 11층
          </SmallText>
        </Box>
      </Accordion>
    </footer>
  );
}
